import { Component } from '@angular/core';
import { NavigationItemComponent } from '../navigation-item/navigation-item.component';
import { NavigationService } from '../navigation.service';
import { ModalService } from '@app/modal/modal.service';
import { SupportMyTicketsModalComponent } from '@app/modals/support-my-tickets-modal/support-my-tickets-modal.component';
import { StoreModalComponent } from '@app/store/store-modal/store-modal.component';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-navigation-tab-games',
  templateUrl: './navigation-tab-games.component.html',
  styleUrl: './navigation-tab-games.component.scss',
  imports: [NavigationItemComponent],
})
export class NavigationTabGamesComponent {
  constructor(public uiService: UIService, public navigationService: NavigationService, private modalService: ModalService) {}

  openSupportModal() {
    this.modalService.open(SupportMyTicketsModalComponent, null, { requiresAuth: true });
  }

  openDepositModal() {
    this.modalService.open(StoreModalComponent, null, { requiresAuth: true });
  }

  openWithDrawModal() {
    this.modalService.open(StoreModalComponent, null, { requiresAuth: true });
  }
}
